/**
 * @generated SignedSource<<fc1152949d63ffba3cd15c4627723827>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type IssueBodySecondaryFragment$data = {
  readonly viewerCanReport: boolean;
  readonly viewerCanReportToMaintainer: boolean;
  readonly " $fragmentType": "IssueBodySecondaryFragment";
};
export type IssueBodySecondaryFragment$key = {
  readonly " $data"?: IssueBodySecondaryFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"IssueBodySecondaryFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "IssueBodySecondaryFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewerCanReport",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewerCanReportToMaintainer",
      "storageKey": null
    }
  ],
  "type": "Issue",
  "abstractKey": null
};

(node as any).hash = "85b54e3b1664179a43fdc11af11a5e2a";

export default node;
